<nz-tabset nzSize="large">
  <nz-tab [nzTitle]="checkIn">
    <ng-template #checkIn>
      <!-- <div>明日入住（{{ checkInTotal }}）</div> -->
      <div>
        {{
          "order.tomorrow_check_in"
            | translate
              : {
                  count: tomorrowCheckin?.total
                }
        }}
      </div>
    </ng-template>
    <host-recent-order-list #tomorrowCheckin type="tomorrow_checkin"></host-recent-order-list>
    <!-- <div class="tab-container">
      <host-today-or-tomorrow-order-list
        [orderList]="checkInList"
        [listTotal]="checkInTotal"
        [channels]="channels"
        [currentLang]="currentLang"
        (refreshModal)="refresh($event)"
        (pageChanged)="pageChanged(1, $event)"
      ></host-today-or-tomorrow-order-list>
    </div> -->
  </nz-tab>
  <nz-tab [nzTitle]="checkOut">
    <ng-template #checkOut>
      <!-- <div>明日退房（{{ checkOutTotal }}）</div> -->
      <div>
        {{
          "order.tomorrow_check_out"
            | translate
              : {
                  count: tomorrowCheckout?.total
                }
        }}
      </div>
    </ng-template>
    <host-recent-order-list #tomorrowCheckout type="tomorrow_checkout"></host-recent-order-list>
    <!-- <div class="tab-container">
      <host-today-or-tomorrow-order-list
        [orderList]="checkOutList"
        [listTotal]="checkOutTotal"
        [channels]="channels"
        [currentLang]="currentLang"
        (refreshModal)="refresh($event)"
        (pageChanged)="pageChanged(2, $event)"
      ></host-today-or-tomorrow-order-list>
    </div> -->
  </nz-tab>
</nz-tabset>
